
declare let UAParser: import('ua-parser-js');

export const getPushName = (parser: UAParser) => {
  const maxLength = 60;
  const device = parser.getDevice();
  const browser = parser.getBrowser();
  const os = parser.getOS();

  const deviceDesc = (device.vendor && device.model) ? `${device.vendor} ${device.model} ` : '';
  const osDesc = (os.name && os.version) ? `${os.name} ${os.version} ` : '';
  const browserDesc = (browser.name && browser.major) ? `(${browser.name} ${browser.major})` : '';
  const desc = (deviceDesc + osDesc + browserDesc).trim();

  return desc ? desc.substr(0, maxLength) : '';
};
